import { useSelector } from "react-redux";
import { permissionAllow } from "../../../util/Helpers";

export const Permission = ({ permission, permissionType = "read", children }) => {
    const adminUser = useSelector(state => state.auth.user);

    const isPermitted = permissionAllow(adminUser, permission, permissionType)

    return isPermitted && children
}